import React, { Component } from 'react';
import { Document, Page } from "react-pdf";
import './thumbnail.css';
import download from 'downloadjs';
import mime from 'mime-types';
import { sliceTo } from '../../../utils/helpers';
import {frontendUrl, host} from '../../../utils/globals';

class Thumbnail extends Component {

    state = {
        numPages: null,
        pageNumber: 1,
        openModal: false
    }

    onDocumentLoad = ({ numPages }) => {
        this.setState({ numPages });
    }

    onDownload = (url, name) => {
        let mimetype = mime.lookup(name);
        let x = new XMLHttpRequest();
        url = window.location.origin.indexOf('localhost') > 0 ? host + url : url;
        x.open("GET", url, true);
        x.responseType = 'blob';
        x.onload = e => download(x.response, name, mimetype);
        x.send();
    }

    increasePage = () => {
        let { pageNumber, numPages } = this.state;
        pageNumber = pageNumber < numPages ? pageNumber + 1 : pageNumber;
        this.setState({
            pageNumber
        })
    }

    decreasePage = () => {
        let { pageNumber, numPages } = this.state;
        pageNumber = pageNumber <= numPages && pageNumber > 1 ? pageNumber - 1 : pageNumber;
        this.setState({
            pageNumber
        })
    }

    toogleModal = e => {
        let openModal = e.target.getAttribute('data-open-modal');
        this.setState({ openModal });
    }

    youtubeParser = (url) => {
            // var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
            var regExp = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/;
            var match = url.match(regExp);
            return (match&&match[1].length==11)? match[1] : false;
    }

    render() {

        const { pageNumber, numPages, openModal } = this.state;
        const { thumbTitle, youtubeLink, isYoutubeLink, thumbImage, thumbDownload, extraClass } = this.props;

        

        if(isYoutubeLink){
            let youtubeVideoId = this.youtubeParser(youtubeLink);
            let youtubeThumnailLink = `https://img.youtube.com/vi/${youtubeVideoId}/mqdefault.jpg`;

            return(  <div class="col-xs-12 col-sm-3">
            <div class="panel panel-default">
                <div class="panel-heading">
            </div>
            <div class="panel-body"><a href={youtubeLink} target="_blank" class="bulletin-item" title={thumbTitle}>
                <figure><img src={youtubeThumnailLink} /></figure><h1 class="text-center"></h1></a></div></div></div>);
        }
        else {
        return (
            <div className={extraClass === 'thumb-meeting' ? "col-xs-12" : "col-xs-12 col-sm-3"}>
                <div className="panel panel-default">
                    <div className="panel-heading">
                        <a href="#" data-toggle="modal" data-target={`#${thumbTitle && thumbTitle.split(" ")[0]}`} data-open-modal={true} onClick={this.toogleModal}>
                            <i className="fa fa-search-plus"></i> Preview
                        </a>
                        <a onClick={() => this.onDownload(thumbDownload, `${thumbTitle}.pdf`)} href="#" className="pull-right">
                            <i className="fa fa-download"></i> Download
                                        </a>
                    </div>
                    <div id={thumbTitle && thumbTitle.split(" ")[0]} className="modal fade" role="dialog">
                        <div className="modal-dialog modal-lg">

                            <div className="modal-content">
                                <div className="modal-header">
                                    <div className="np-btn pull-right">
                                        <a
                                            onClick={() => this.onDownload(thumbDownload, `${thumbTitle}.pdf`)}
                                            className="preview-modal-download"
                                        >
                                            <i className="fa fa-download"/> Download
                                        </a>
                                        <span onClick={this.decreasePage}>
                                            <i className="fa fa-angle-double-left"></i>
                                        </span>
                                        <span>{`${pageNumber} of ${numPages}`}</span>
                                        <span onClick={this.increasePage}>
                                            <i className="fa fa-angle-double-right"></i>
                                        </span>
                                    </div>
                                    <h4 className="modal-title">{thumbTitle}</h4>
                                </div>
                                <div className="modal-body">
                                    { openModal && (
                                        <Document file={thumbDownload} onLoadSuccess={this.onDocumentLoad}>
                                            <Page pageNumber={pageNumber} />
                                        </Document>
                                    ) }
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-default" data-dismiss="modal" data-open-modal={false} onClick={this.toogleModal}>Close</button>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="panel-body">
                        <a href={`${frontendUrl}${thumbDownload}`}
                           target="_blank"
                           className="bulletin-item"
                           title={thumbTitle}>
                            <figure>
                            <img src={thumbImage} />
                                            {/* //insert logo here */}
                            </figure>
                            <h1 className="text-center">
                                {sliceTo(thumbTitle, 50)}
                            </h1>
                        </a>
                    </div>
                </div>
            </div>

        )
    }
    }
};



export default Thumbnail;